/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import { IModelConnection, ScreenViewport } from "@itwin/core-frontend";

import { cQuery } from "./Query";
import { cSelection } from "./Selection";
import { cMarker, MarkerData } from "./Marker";

export class cLabel {
  private static iModel: IModelConnection;
  private static sViewPort: ScreenViewport;
  private static _showLabel: boolean;

  public static initLabel = (vp: ScreenViewport, imodel: IModelConnection) => {
    this.iModel = imodel;
    this.sViewPort = vp;

    cMarker.createMarkerSet("Labels");

    this.showLabel(false);
  }

  public static showLabel = async (showHide: boolean) => {
    this._showLabel = showHide;

    if (showHide === true) {
      await this.displayLabels();
      cMarker.enableMarkerSet("Labels");

      cSelection.setOnElementSelected("elementLabel", this.displayLabels);
    } else {
      cMarker.removeAllMarkers("Labels");
      cMarker.disableMarkerSet("Labels");

      cSelection.setOnElementSelected("elementLabel");
    }
  }

  public static displayLabels = async () => {
    if (!this._showLabel) return;

    cMarker.removeAllMarkers("Labels");

    const elements = cSelection.getSelections();
    for (const elementId of elements) {
      const tag = await cQuery.getElementTag([elementId]);
      if (!tag || tag[0].toLowerCase().includes(".jpg")) {
        return;
      }
      
      const range = await cQuery.getElementRange(elementId);
      if (range) {
        const markerData = new MarkerData();
        markerData.id = tag[0]!;
        // markerData.title = tag!;
        // markerData.description = "";
        markerData.label = tag[0]!;
        markerData.point = range.center;
        cMarker.addMarkerPoint("Labels", markerData, 0);
      }
    }
  }
}
